export default __webpack_public_path__ + "static/media/logo.6b85a07f.svg";